export function cleanEmptyEndHTML(html: string): string {
  // Find <p></p> and <p><br></p> who are not followed by a <p>...</p> and remove them
  const regex = /(<p><\/p>|<p><br><\/p>)(?!.*<p>[^<>]+<\/p>)/g;
  return html.replace(regex, '');
}
